'use client';

import ExchangeSection5 from '@enlighten/landing/dist/exchange/@section5';

export default function Section5() {
	return (
		<ExchangeSection5
			onRequest={() => {
				window.open('https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=16730758901529', '_blank');
			}}
			onConsult={() => {
				window.open('tel:02-6231-1504');
			}}
		/>
	);
}
